/*==========================================================
INITIALIZE HOMEPAGE SCRIPT
==========================================================*/
$(document).ready(function () {
    if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
        //hide contentHome if no content
        if ($('#contentHome').text().trim().length === 0) { $('#contentHome').hide(); }
    }
});
